import { createAsyncThunk } from "@reduxjs/toolkit"
import { ZipFileList,ZipFileName } from "@/gluelayer/core/common/types"
import {
  forcelockCaseSever,
  getCaseByPatient,
  getFileInfo,
  getFileZips,
  downloadRefinementFile,
  getIsRead,
  getMessage,
  lockCaseSever,
  postMessage,
  postModiMessage,
  unlockCaseSever,
  updateMessage,
  uploadZips,
  deleteFiles
} from "./clinical.service"
import {
  clinicalRequestBasicType,
  getZipsType,
  messageBody,
  UploadZips,
  IWasmInitOption,
  UploadFileInfo,
  IFetchZipsAndUpdateVirtualFS,
  IfetchZipsFromCacheOrRemote
} from "./clinical.types"
import{
  fetchRefinementJsonFile
} from "./refinement/refinementThunkApi"


import { 
  caseManagement,
  wasmModule,
  resourcesSynchronization
 } from "@/gluelayer"


export const fetchFileListWeDesign = createAsyncThunk(
  "clinicalService/fetchFileListWeDesign",
  async (
    { orgId, patientId, caseId, fileNames }: clinicalRequestBasicType,
    { rejectWithValue, getState },
  ) => {
    try {
      return await getFileInfo({ orgId, patientId, caseId })
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const fetchFileZipsWeDesign = createAsyncThunk(
  "clinicalService/fetchFileZips",
  async (
    { orgId, patientId, caseId, zipNames }: getZipsType,
    { rejectWithValue, getState },
  ) => {
    try {
      return await getFileZips({ orgId, patientId, caseId, zipNames })
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)


export const fetchFileList = createAsyncThunk(
  "clinicalService/fetchFileList",
  async (
    { patientId, caseId }: clinicalRequestBasicType,
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await getFileInfo({ orgId, patientId, caseId })
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const getTreatmentInfos = createAsyncThunk(
  "clinicalService/getTreatmentInfos",
  async ({ patientId }: any, { rejectWithValue, getState }) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await getCaseByPatient(orgId, patientId)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)


/**
 * 下载zip文件并更新虚拟文件系统
 * todo: 这里需要优化，当下载的时候，更新虚拟文件系统。避免前端逻辑中不必要的处处对虚拟文件系统的操作。
 */
export const fetchZipsAndUpdateVirtualFS = createAsyncThunk<Record<string,Blob>,IFetchZipsAndUpdateVirtualFS>(
  "clinicalService/fetchZipsAndUpdateVirtualFS",
  async (
    { patientId, caseId, zipNames ,isDownloadRetouchHistory = false},
    { rejectWithValue, dispatch },
  ) => {
    try {
      const ret:any = await dispatch(fetchZipsFromCacheOrRemote({ patientId, caseId, zipNames,isDownloadRetouchHistory }))

      const zips = ret.payload

      await resourcesSynchronization.writeCaseFilesToVirtualFS(zips)
      return zips

    } catch (err) {
      return rejectWithValue(err)
    }
  },
)


// for new workflow of opening case
export const fetchZipsFromCacheOrRemote = createAsyncThunk<Record<string,Blob>,IfetchZipsFromCacheOrRemote>(
  "clinicalService/fetchZipsFromCacheOrRemote",
  async (
    {caseId,patientId,zipNames,isDownloadRetouchHistory},
    { rejectWithValue, getState,dispatch },
  )=>{

    // get zips from remote
    const getZipsFromReomte = async ()=>{
      try {

        const orgId = (getState()as any).userService.user.current_orgId
        const promises:Promise<any>[] = [
          /**
           * download case zips
           */
          //dispatch(fetchFileZips({ orgId, patientId, caseId, zipNames:["bulk0", "bulk1", "bulk2", "bulk10", "photo", "raw"] }))
          dispatch(fetchFileZips({ orgId, patientId, caseId, zipNames})).then(
            (res)=>{
              return res.payload
            }
          )
        ]

        if(isDownloadRetouchHistory){
            /**
            * download refinementjson
            */
            const refinementFiles = (getState()as any).clinicalService.refinementFiles
            if (refinementFiles.length) {
              promises.push(
                dispatch(
                  fetchRefinementJsonFile({
                    orgId: "",
                    patientId,
                    caseId,
                    refinementFiles,
                  }),
              )
            )
          }
        }

        // 等待所有异步任务完成
        await Promise.all(promises);

        const zipList = (getState()as any).clinicalService.zipList;
        const retFiles:Record<string,Blob> = {}
        Object.keys(zipList).find((key)=>{
          const keyName = key.replace(".zip","")
          if(zipNames.includes(keyName)){
            retFiles[key] = zipList[key]
          }
          if(isDownloadRetouchHistory && key.includes("RetouchHistory/")){
            retFiles[key] = zipList[key]
          }
        })
        console.log("retFiles>>>:",retFiles)

        return retFiles;
        
      } catch (err) {
        console.warn("fetchFileZips from remote error:",err)
        return rejectWithValue(err)
      }
    }
    try{
        // To be optimized:这段比对目前不能针对下载的文件去比对，而是整体filelist比对，所以不准确，后续需要优化
        // get fileList and check if need download zips from remote
        // await dispatch(fetchFileList({caseId,patientId,checkFileUpdates:true}));
        // const isCaseFilesUpdated = (getState()as any).clinicalService.isCaseFilesUpdated;
        // console.log("isCaseFilesUpdated:",isCaseFilesUpdated,(getState()as any).clinicalService)

        // if (isCaseFilesUpdated) {
        //   console.log("Case need Update getZipsFromRemote")
        //   return getZipsFromReomte();
        // }else{

          const caches = (getState()as any).cacheService.caches;
          const cache:Record<string,Blob> = caches[caseId];
        
          // there is some issue of cacheService, it don't check the case is need update or not. if cache is exist, it will return the cache directly.
          if(!cache){
              console.log("No Cache, fetchZipsFromRemote")
              return getZipsFromReomte();
          }else{
            //check if files in zipNames exist in the zipList
            let zipsExist=true
            let retFiles:Record<string,Blob> = {}
            for (const name of zipNames) {
              if (!cache[`${name}.zip`]) {
                zipsExist=false
                break
              }
              retFiles[`${name}.zip`] = cache[`${name}.zip`]
            }
            Object.keys(cache).find((key) => {
              if (isDownloadRetouchHistory && key.includes("RetouchHistory/")) {
                retFiles[key] = cache[key]
              }
            })

            const refinementFiles = (getState()as any).clinicalService.refinementFiles
            for (const name of refinementFiles) {
              if (name === "RetouchHistory.json" && !cache[`RetouchHistory/${name}`]) {
                zipsExist=false
                break
              }
            }

            if(!zipsExist)
            {
              console.log("cache doesn't have files needful")
              return getZipsFromReomte();
            }else{
              console.log("fetchZipsFromCache",retFiles)
              return retFiles;
            }
          }
        // }
    }catch(err){
      console.warn("fetchFileList error:",err)
      return rejectWithValue(err)
    }

  }
)


export const fetchFileZips = createAsyncThunk(
  "clinicalService/fetchFileZips",
  async (
    { patientId, caseId, zipNames }: getZipsType,
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await getFileZips({ orgId, patientId, caseId, zipNames })
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)



export const uploadCaseZips = createAsyncThunk(
  "clinicalService/uploadFileZips",
  async (
    { patientId, caseId, zips, skipLockCheck=null }: UploadZips,
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await uploadZips({ orgId, patientId, caseId, zips, skipLockCheck })
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export interface IDeleteCaseFilesParams{
  patientId: string | undefined
  caseId: string | undefined
  fileNames:string[] // file names include postfix
}


export const deleteCaseFiles = createAsyncThunk(
  "clinicalService/deleteCaseFiles",
  async (
    { patientId, caseId, fileNames }: IDeleteCaseFilesParams,
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await deleteFiles({ orgId, patientId, caseId, fileNames })
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)


/**
 * 可上传的文件名
 */
export type UploadAbledFileName = 'bulk0.zip' | 'bulk1.zip' | 'bulk2.zip' | 'bulk10.zip' | 'raw.zip' | 'photo.zip' | 'RetouchHistory.json'


export interface uploadCaseFilesByFileNamesParams{
  patientId: string | undefined
  caseId: string | undefined
  fileNames:UploadAbledFileName[]
  skipLockCheck?: string | number | null
}

/**
 * 上传病例文件，提供文件名即可，该方法会去虚拟目录取文件
 * @param {
 *  patientId: 患者ID
 *  caseId: 病例ID
 *  fileNames: UploadAbledFileName[]
 * type UploadAbledFileName = 'bulk0.zip' | 'bulk1.zip' | 'bulk2.zip' | 'bulk10.zip' | 'raw.zip' | 'photo.zip' | 'RetouchHistory.json'
 * } 
 * @returns 
 */
export const uploadCaseFilesByFileNames = createAsyncThunk(
  "clinicalService/uploadCaseFilesByFileNames",
  async (
    { patientId, caseId, fileNames,skipLockCheck=null }: uploadCaseFilesByFileNamesParams,
    { rejectWithValue, getState,dispatch },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      
      // get zips from the virtual directory
      const zipNames = [] as ZipFileList
      for (let i = 0; i < fileNames.length; i++) {
        const fileName = fileNames[i];
        const [prefox,postfix] = fileName.split(".") as [ZipFileName,string]
    
        if (postfix !== "zip") {
          continue
        }
        zipNames.push(prefox)
      }
      const zipFiles = await caseManagement.getCaseFiles(zipNames)
    
      const uploadfileList = [] as UploadFileInfo[]
      for (const key in zipFiles ) {
        uploadfileList.push({
          fileName: key,
          file: zipFiles[key],
          isRefinement: "0"
        })
      }
    
      if (fileNames.includes("RetouchHistory.json")) {
        // update RetouchHistory.json
        const jsonFile = new File(
          [
            await wasmModule.module.FS.readFile(
              "/test/case/RetouchHistory/RetouchHistory.json",
            ),
          ],
          "RetouchHistory.json",
          {
            type: "application/json",
            lastModified: Date.now(),
          },
        )
        uploadfileList.push({
          fileName: "RetouchHistory.json",
          file: jsonFile,
          isRefinement: "1"
        })
      }

      // upload files
      return await dispatch(uploadCaseZips({     
        patientId,
        caseId,
        zips: uploadfileList,
        orgId, 
        skipLockCheck 
      }))

    } catch (err) {
      return rejectWithValue(err)
    }
  },
)


export const postMessageApi = createAsyncThunk(
  "clinicalService/postMessage",
  async (
    { patientId, caseId, subject, txName, content }: messageBody,
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await postMessage({
        orgId,
        patientId,
        caseId,
        subject,
        txName,
        content,
      })
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const postModiApi = createAsyncThunk(
  "clinicalService/postModiApi",
  async (
    {
      patientId,
      caseId,
      subject,
      txName,
      content,
      is_modification_requested,
    }: messageBody,
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await postModiMessage({
        orgId,
        patientId,
        caseId,
        subject,
        txName,
        content,
        is_modification_requested,
      })
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const getMessageApi = createAsyncThunk(
  "clinicalService/getMessage",
  async (
    { patientId, caseId }: clinicalRequestBasicType,
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await getMessage({
        orgId,
        patientId,
        caseId,
      })
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const getIsReadApi = createAsyncThunk(
  "clinicalService/getIsRead",
  async (
    { patientId, caseId }: clinicalRequestBasicType,
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await getIsRead({
        orgId,
        patientId,
        caseId,
      })
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)


export const lockCaseApi = createAsyncThunk(
  "clinicalService/lockCaseApi",
  async (
    { patientId, caseId }: clinicalRequestBasicType,
    { rejectWithValue, getState },
  ) => {
    const orgId = getState()?.userService?.user?.current_orgId
    try {
      return await lockCaseSever({
        orgId,
        patientId,
        caseId,
      })
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const unlockCaseApi = createAsyncThunk(
  "clinicalService/unlockCaseApi",
  async (
    { patientId, caseId, isForceUnlock }: clinicalRequestBasicType,
    { rejectWithValue, getState },
  ) => {
    const orgId = getState()?.userService?.user?.current_orgId
    try {
      return await unlockCaseSever({
        orgId,
        patientId,
        caseId,
        isForceUnlock
      })
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const forcelockCaseApi = createAsyncThunk(
  "clinicalService/forcelockCaseApi",
  async (
    { patientId, caseId, isForceModify=false }: clinicalRequestBasicType,
    { rejectWithValue, getState },
  ) => {
    const orgId = getState()?.userService?.user?.current_orgId
    try {
      return await forcelockCaseSever({
        orgId,
        patientId,
        caseId,
        isForceModify
      })
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const updateMessageApi = createAsyncThunk(
  "clinicalService/updateMessage",
  async (
    { patientId, caseId, messageId, cb, ...payload }: messageBody,
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await updateMessage({
        orgId,
        patientId,
        caseId,
        messageId,
        ...payload,
      })
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)


export const initializeWASM = createAsyncThunk(
  "clinicalService/initializeWASM",
  async (
    {canvas }:IWasmInitOption,
    { rejectWithValue, getState },
  )=>{
    return caseManagement.initWasm(canvas,()=>{
      console.log('wasminit ok!');
    })
  }
)